export function GraphicsPanel() {
  return (
    <div className="px-2">
      {/* Section header */}
      <div className="mb-4">
        <h3 className="text-sm font-semibold uppercase tracking-wider px-1">Graphics</h3>
        <p className="text-xs text-slate-400 mt-1 px-1">Shapes and graphics will appear here</p>
      </div>

      {/* Empty State Only */}
      <div className="mt-4 p-6 bg-slate-50 border-2 border-dashed border-slate-200 rounded-xl text-center">
        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center">
          <svg
            viewBox="0 0 24 24"
            className="w-8 h-8 text-slate-400"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <title>Graphics</title>
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <circle cx="17" cy="7" r="4" />
            <path d="M4 17l4-4 4 4 4-4 4 4" />
          </svg>
        </div>

        <p className="text-sm font-medium text-slate-600 mb-1">No graphics available</p>
        <p className="text-xs text-slate-500">This section is currently empty</p>
      </div>
    </div>
  );
}
